import { QRCodeSVG } from 'qrcode.react';
import PropTypes from 'prop-types';

const QrDisplayerComponent = ({ value, size, level, includeMargin }) => {
    return <QRCodeSVG value={value} size={size} level={level} includeMargin={includeMargin} />;
};

export default QrDisplayerComponent;
QrDisplayerComponent.propTypes = {
    value: PropTypes.string,
    size: PropTypes.number,
    level: PropTypes.string,
    includeMargin: PropTypes.bool
};
